import React, { useState } from 'react';
import TestListPage from './TestListPage';
import TestStartPage from './TestStartPage';
import TestRunner from './TestRunner';
import ResultsSummary from './ResultsSummary';
import AnswerReview from './AnswerReview';

interface TestyModuleProps {
  onNavigate?: (section: string) => void;
}

const TestyModule: React.FC<TestyModuleProps> = ({ onNavigate }) => {
  const [currentView, setCurrentView] = useState<'list' | 'start' | 'runner' | 'summary' | 'review'>('list');
  const [selectedTestId, setSelectedTestId] = useState<string | null>(null);

  const handleTestyNavigation = (section: string, testId?: string) => {
    switch (section) {
      case 'test-start':
        if (testId) {
          setSelectedTestId(testId);
          setCurrentView('start');
        }
        break;
      case 'test-runner':
        if (testId) {
          setSelectedTestId(testId);
          setCurrentView('runner');
        }
        break;
      case 'test-summary':
        if (testId) {
          setSelectedTestId(testId);
          setCurrentView('summary');
        }
        break;
      case 'test-review':
        if (testId) {
          setSelectedTestId(testId);
          setCurrentView('review');
        }
        break;
      case 'upgrade':
        // Pass upgrade navigation up to the main Dashboard
        if (onNavigate) {
          onNavigate('upgrade');
        }
        break;
      case 'test-list':
      default:
        setCurrentView('list');
        setSelectedTestId(null);
        break;
    }
  };

  // For now, only implement the test list view
  // Other views will be implemented in subsequent tasks
  switch (currentView) {
    case 'list':
      return <TestListPage onNavigate={handleTestyNavigation} />;
    
    case 'start':
      return selectedTestId ? (
        <TestStartPage testId={selectedTestId} onNavigate={handleTestyNavigation} />
      ) : (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">❓</div>
          <h2 className="text-2xl font-semibold text-light-text-primary dark:text-dark-text-primary mb-2 font-poppins">
            Test nenalezen
          </h2>
          <p className="text-light-text-secondary dark:text-dark-text-secondary font-poppins mb-4">
            Nebyl vybrán žádný test.
          </p>
          <button
            onClick={() => handleTestyNavigation('test-list')}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-lg font-poppins font-medium transition-colors duration-200"
          >
            Zpět na seznam testů
          </button>
        </div>
      );
    
    case 'runner':
      return selectedTestId ? (
        <TestRunner testId={selectedTestId} onNavigate={handleTestyNavigation} />
      ) : (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">❓</div>
          <h2 className="text-2xl font-semibold text-light-text-primary dark:text-dark-text-primary mb-2 font-poppins">
            Test nenalezen
          </h2>
          <p className="text-light-text-secondary dark:text-dark-text-secondary font-poppins mb-4">
            Nebyl vybrán žádný test.
          </p>
          <button
            onClick={() => handleTestyNavigation('test-list')}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-lg font-poppins font-medium transition-colors duration-200"
          >
            Zpět na seznam testů
          </button>
        </div>
      );
    
    case 'summary':
      return selectedTestId ? (
        <ResultsSummary testId={selectedTestId} onNavigate={handleTestyNavigation} />
      ) : (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">❓</div>
          <h2 className="text-2xl font-semibold text-light-text-primary dark:text-dark-text-primary mb-2 font-poppins">
            Test nenalezen
          </h2>
          <p className="text-light-text-secondary dark:text-dark-text-secondary font-poppins mb-4">
            Nebyl vybrán žádný test.
          </p>
          <button
            onClick={() => handleTestyNavigation('test-list')}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-lg font-poppins font-medium transition-colors duration-200"
          >
            Zpět na seznam testů
          </button>
        </div>
      );
    
    case 'review':
      return selectedTestId ? (
        <AnswerReview testId={selectedTestId} onNavigate={handleTestyNavigation} />
      ) : (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">❓</div>
          <h2 className="text-2xl font-semibold text-light-text-primary dark:text-dark-text-primary mb-2 font-poppins">
            Test nenalezen
          </h2>
          <p className="text-light-text-secondary dark:text-dark-text-secondary font-poppins mb-4">
            Nebyl vybrán žádný test.
          </p>
          <button
            onClick={() => handleTestyNavigation('test-list')}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-lg font-poppins font-medium transition-colors duration-200"
          >
            Zpět na seznam testů
          </button>
        </div>
      );
    
    default:
      return (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">🚧</div>
          <h2 className="text-2xl font-semibold text-light-text-primary dark:text-dark-text-primary mb-2 font-poppins">
            Stránka v přípravě
          </h2>
          <p className="text-light-text-secondary dark:text-dark-text-secondary font-poppins mb-4">
            Tato část testovacího systému bude brzy dostupná.
          </p>
          <button
            onClick={() => handleTestyNavigation('test-list')}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-lg font-poppins font-medium transition-colors duration-200"
          >
            Zpět na seznam testů
          </button>
        </div>
      );
  }
};

export default TestyModule;